<template>
  <div class="match-invite-page page">
    <!-- 顶部 -->
    <page-top></page-top>
    <!-- 头部 -->
    <Header @chooseTab="getTab" currentIndex="3"></Header>
    <!-- 主体 -->
    <main class="main">
      <section class="breadcrumb-plate">
        <div class="label">我的位置：</div>
        <breadcrumb />
      </section>

      <section class="content w">

        <div class="c-left">
          <tab-vertical :tabData="tabList" :code="categoryId" :seccode="seccode" :subcode="subcode" @changeSecTab="changeSecTab"></tab-vertical>

        </div>
        <div class="c-right">

          <div class="title-wrap">
            <span class="c-title">{{currentCategory?.categoryName}}</span>
            <span class="english-name">{{currentCategory?.englishName}}</span>
          </div>

          <div class="desc">
            <div class="title">
              <div>服务介绍</div>
            </div>
            <div class="article-content" v-html="article.articleContent"></div>
          </div>

          <div class="service-mien">
            <div class="mien-head">
              <div class="left-img">
                <img :src="
                        $globalHeader.fileUrl +
                        '/static/fjtwfw/web-competition-detail-plan-left.png'
                      " />
              </div>
              <div class="title">资讯</div>
              <div class="right-img">
                <img :src="
                        $globalHeader.fileUrl +
                        '/static/fjtwfw/web-competition-detail-plan-right.png'
                      " />
              </div>
            </div>
          </div>

          <div class="new-list" v-if="newsList">
            <div class="news-item" v-for="(item, index) in newsList" :key="index" @click="toArticleDetail(item)">
              <div class="news-title">
                {{ item.articleName }}
              </div>
              <div class="news-time">
                {{ item.releaseTime }}
              </div>
            </div>
          </div>
          <el-empty description="暂无内容~" v-if="newsList.length == 0"></el-empty>
          <!-- 页码 -->
          <div class="m-bot" v-if="newsList.length > 0 ">
            <el-pagination background layout="prev, pager, next" prev-text="上一页" next-text="下一页" :page-size="pageSize" :total="pageCount" @current-change="changePageClick">
            </el-pagination>
          </div>

        </div>
      </section>
    </main>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import pageTop from "@/components/common/pageTop.vue";
import Header from "@/components/common/header.vue";
import Footer from "@/components/common/footer.vue";
import Breadcrumb from "@/components/common/breadcrumb";
import TabVertical from "@/components/list/tab-vertical.vue";

import { getArticleById, getArticlePage } from "@/api/home/home.js";
import { getNavItemByCode } from "@/api/common/common.js";
export default {
  name: "Policy",
  components: { pageTop, Header, Footer, Breadcrumb, TabVertical },
  data() {
    return {
      pageSize: 6, //分页数量
      pageCount: 0, //列表总数
      displayNewsList: true,

      tabList: [],
      tabTitle: "新闻中心",
      newsList: [],
      article: "",
      pageType: "", //1 文章内容，2 文章列表
      categoryId: "",
      tabcode: "",
      seccode: "",
      subcode: "",
      currentCategory: {
        categoryName: '',
        englishName: ''
      }
    };
  },
  methods: {
    //统一获取数据
    fetchData() {
      if (!this.tabcode) return;
      getNavItemByCode(this.tabcode).then((res) => {
        if (!res.data) return;
        //侧边栏列表
        this.tabList = res.data[0];


        if (this.categoryId == this.tabList.categoryCode) {
          this.currentCategory = this.tabList
        } else if (this.currentCategory.categoryName == '' && this.tabList.list) {
          this.currentCategory = this.tabList.list.find(p =>
            this.categoryId == p.categoryCode
          );
        }

      })


    },
    //获取header组件的点击事件
    getTab(data) {
      if (data && typeof data == "string") {
        this.$router.push("/" + data);
      }
    },
    // 文章信息--富文本
    getArticleData(id) {
      getArticleById(id).then((res) => {
        if (!res.data) return;
        this.article = res.data;
      });
    },
    //点击改变栏目
    changeSecTab(item, tab) {
      this.currentCategory = item
      console.log("item", this.currentCategory);
      console.log("tab", tab);
      let url = "?categoryId=" + item.categoryCode + "&linkType=" + item.linkType + "&tabcode=" + this.tabcode
      url = tab ? url + '&seccode=' + tab : url

      this.seccode = tab//二级标题
      this.categoryId = item.categoryCode;//当前标题
      this.subcode = item.categoryCode;//三级标题
      this.pageType = item.linkType;
      if (this.tabList.list && this.tabList.list.length > 0) {
        const targetItem = this.tabList.list.find(item => item.categoryCode == this.categoryId);

        if (this.categoryId == this.seccode && targetItem?.list?.length) {
          item = item.list[0]
          this.seccode = targetItem.categoryCode;
          this.subcode = targetItem.list[0].categoryCode;
          this.categoryId = targetItem.list[0].categoryCode;
        }
      }
      this.getServiceArticlePage(item.categoryCode)

      // 展示富文本
      //链接类型：1/文章详情,2/单图列表,3/图文列表,4/文本列表,5/切换详情列表
      if (item.linkType == 1) {
        this.getArticleData(item.linkUrl);
        url = "/train/article" + url + '&id=' + item.linkUrl
      }
      if (item.linkType == 2) {
        url = "/train/singleImage" + url
      }
      if (item.linkType == 3) {
        console.log(item.linkType);
      }
      if (item.linkType == 4) {
        console.log(item.linkType);
      }
      if (item.linkType == 5) {
        url = "/tabList" + url + '&id=' + item.linkUrl
      }
      this.$router.push({
        path: url,
      });
      if (item.linkUrl != "null" && item.linkUrl) return this.getArticleData(item.linkUrl);



    },
    //获取文章列表
    getServiceArticlePage(categoryCode, page = 1) {
      getArticlePage({
        page: page,
        limit: 6,
        categoryCode: categoryCode,
      }).then((res) => {
        console.log(res.data);
        if (!res.data) return;
        this.newsList = res.data.list;
        this.pageCount = Number(res.data.count);
      });
    },
    //切换页面
    changePageClick(page) {
      this.getServiceArticlePage(this.currentCategory.categoryCode, page);
    },
    toArticleDetail(item) {
      let url = "/articleDetail?categoryId=" + this.currentCategory.categoryCode + "&linkType=3&tabcode=" + this.tabcode + "&seccode=" + this.seccode + "&id=" + item.articleId;
      this.$router.push(url);
    }
  },
  created() {
    this.pageType = this.$route.query?.linkType;
    let id = this.$route.query?.id;
    this.categoryId = this.$route.query?.categoryId;
    this.tabcode = this.$route.query?.tabcode;
    this.seccode = this.$route.query?.seccode;
    this.fetchData();
    this.getServiceArticlePage(this.categoryId)

    if (id != "null" && id) return this.getArticleData(id);
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-breadcrumb__inner.is-link,
/deep/ .el-breadcrumb__inner.is-link:hover {
  color: #fff;
}
/deep/ .el-breadcrumb__separator,
/deep/ .el-breadcrumb__separator:hover {
  color: #fff;
}
/deep/ .el-breadcrumb__item:last-child .el-breadcrumb__inner,
/deep/.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  color: #fff;
}

.match-invite-page {
  .main {
    flex: 1;
    padding-bottom: 80px;
    background-color: #ffffff;
    margin-top: 60px;

    .breadcrumb-plate {
      background: linear-gradient(to top, #347cd0 0%, #62a3f0 100%);
      color: #fff;

      display: flex;
      align-items: center;
      padding: 16px 0;
      padding-left: 180px;

      .label {
        line-height: 1;
        font-size: 14px;
      }
    }

    .content {
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      margin-top: 50px;
      margin-bottom: 100px;

      .c-top {
        display: flex;
        justify-content: center;
      }

      .c-left {
        flex: 1;
        display: flex;
        justify-content: center;
        background-color: #fff;
        padding-bottom: 70px;

        .picture {
          img {
            width: 280px;
            height: 280px;
          }

          p {
            padding-top: 20px;
            padding-left: 20px;
            font-size: 14px;
            color: #8d8d8d;
          }
        }
      }
      .c-right {
        flex: 4;
        margin-left: 60px;
        margin-top: 10px;

        .title-wrap {
          margin-bottom: 10px;
          .c-title {
            font-size: 28px;
            padding-left: 17px;
            border-left: 3px solid rgb(12, 108, 228);
            font-weight: 700;
          }
          .english-name {
            color: rgb(153, 153, 153);
            margin-left: 10px;
          }
        }
        .desc {
          margin-top: 20px;
          font-size: 15px;
          line-height: 30px;
          box-shadow: -2px 2px 20px 0 #dbefffad;
          -webkit-box-shadow: -2px 2px 20px 0 #dbefffad;
          padding: 20px;
          .title {
            position: relative;
            top: -20px;
            left: -20px;
            width: 120px;
            height: 40px;
            background: linear-gradient(to right, #ffcd34, #ff9200);
            color: #fff;
            font-weight: bold;
            border-bottom-right-radius: 15px;

            div {
              padding-top: 4px;
              padding-left: 30px;
            }
          }
          .article-content {
          }
        }
        .service-mien {
          margin-top: 90px;
          .mien-head {
            display: flex;
            .left-img {
              flex: 2;
              text-align: right;
            }
            .right-img {
              flex: 2;
            }
            .title {
              flex: 1;
              text-align: center;
              font-size: 26px;

              color: #4ea4f9;
              font-weight: bold;
              letter-spacing: 10px;
              background: linear-gradient(180deg, #47b8f9 0%, #597af8 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
            img {
              width: 63px;
              height: 39px;
            }
          }
        }
        .new-list {
          padding: 10px 20px;
          display: flex;
          flex-direction: column;
          .news-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 18px 0;

            .news-title {
              flex: 1;
              display: -webkit-box;
              word-break: break-all;
              text-overflow: ellipsis;
              overflow: hidden;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              font-size: 16px;
            }

            .news-time {
              margin-left: 20px;
              color: #999;
            }
          }
          .news-item:hover .news-title,
          .news-item:hover .news-time {
            color: #2a79ee;
            cursor: pointer;
          }
          .news-item {
            border-bottom: 1px dashed #d7d7d7;
          }
        }
        .m-bot {
          margin-top: 24px;
          margin-bottom: 24px;

          .el-pagination {
            display: flex;
            justify-content: center;

            /deep/ .btn-prev {
              width: 100px;
              height: 40px;
              border: 1px solid #e4e4e4;
              background-color: #fff;
            }

            /deep/ .btn-prev:hover:enabled {
              color: #409eff;
            }

            /deep/ .number {
              width: 40px;
              height: 40px;
              line-height: 40px;
              border: 1px solid #e4e4e4;
              background-color: #fff;
            }

            /deep/ .more {
              width: 40px;
              height: 40px;
              line-height: 40px;
              border: 1px solid #e4e4e4;
              background-color: #fff;
            }

            /deep/ .btn-next {
              width: 100px;
              height: 40px;
              border: 1px solid #e4e4e4;
              background-color: #fff;
            }

            /deep/ .btn-next:hover:enabled {
              color: #409eff;
            }

            /deep/ .active {
              color: #fff;
              background-color: #409eff;
            }
          }
        }
      }
    }
  }
}
</style>
